import React from 'react';
import { Link } from 'react-router-dom';

import Footer from '../../components/layout/Footer';
import PublicNavbar from '../../components/layout/PublicNavbar';
import Button from '../../components/ui/Button';

export default function BiogasPage() {
  return (
    <div className="overflow-x-hidden bg-white text-gray-900">
      <PublicNavbar />
      <main className="mx-auto max-w-5xl px-6 pb-20 pt-32">
        <Link to="/" className="text-sm text-green-700 hover:text-green-800">
          ← Back to Atharva
        </Link>
        <span className="ml-3 inline-flex items-center gap-2 rounded-full bg-emerald-100 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-emerald-700">
          Clean Energy
        </span>
        <h1 className="mt-6 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
          Village Biogas Initiative
        </h1>
        <p className="mt-4 max-w-2xl text-lg text-gray-600">
          Transforming agricultural waste into clean cooking gas and organic fertilizer for rural
          families. Replacing LPG, one village at a time.
        </p>
        <div className="mt-10 grid gap-6 sm:grid-cols-3">
          {[
            { label: 'Families served', value: '500+' },
            { label: 'Villages active', value: '12' },
            { label: 'CO₂ offset / year', value: '2T+' },
          ].map((s) => (
            <div key={s.label} className="rounded-2xl border border-emerald-100 bg-emerald-50 p-5">
              <div className="text-3xl font-extrabold text-emerald-800">{s.value}</div>
              <div className="mt-1 text-xs uppercase tracking-wider text-emerald-700">{s.label}</div>
            </div>
          ))}
        </div>
        <p className="mt-10 text-sm text-gray-500">
          The full biogas project page — process diagrams, impact stories, photos — is being rebuilt
          under the new design system.
        </p>
        <div className="mt-8 flex gap-3">
          <a href="mailto:partner@atharva.org">
            <Button>Partner with us</Button>
          </a>
          <Link to="/">
            <Button variant="secondary">Back to home</Button>
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
